import React, { useEffect, useRef, useState } from 'react'
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import UploadFile from 'components/Common/ElementInForm/UploadFile/UploadFile';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { AlertTitleTh, Extension } from 'service/CommonFunction/TS_function';
import { BtnAdd, BtnConfirm, BtnDelete, BtnSave, BtnSearchOnTable, BtnSend } from 'components/Common/Button';
import { GridColumns } from '@mui/x-data-grid-pro';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import { SwAlert } from 'components/Common/Alert/AlertForm';

const CpnSolutionResolve = (props) => {
    const {
        form,
        DataRowResolve,
        arrFileResolve,
        setarrFileResolve,
        onAddResolve2Table,
        onDeleteArrResolve,
        onClearFileResolve,
        nStatusID,
        sMode,
        objPermission,
        onHandleCloning,
        IsCanCloning,
        setIsCanCloning
    } = props;

    const [IsView, setIsView] = useState(false)

    useEffect(() => {
        setIsView(sMode === "view" || objPermission?.Resolved?.isDisable == true)
        // setIsCanCloning()
    }, [props.sMode])

    const GotoFilePath = (item) => {
        window.open(item.row?.sFileLink ?? "/");
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sFileName",
            headerName: "เอกสาร",
            headerAlign: "center",
            flex: 1,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                return (
                    <>
                        <BtnSearchOnTable txt='ดู' onClick={() => { GotoFilePath(item) }} /> &nbsp;&nbsp;&nbsp;
                        <Typography component={"label"} style={{ wordBreak: 'break-word' }}>
                            {item.value}
                        </Typography>
                    </>
                );
            },
        },

        {
            field: "",
            headerName: "",
            headerAlign: "center",
            width: 40,
            align: "center",
            resizable: false,
            disableReorder: true,
            sortable: false,
            renderCell: (item) => {
                return (
                    <>
                        {
                            IsView ? null
                                :
                                <BtnDelete
                                    isCircleWithOutText={true}
                                    onClick={() => { onDeleteArrResolve(item.row) }}
                                />
                        }
                    </>
                );
            },
        },
    ];



    return (
        <>
            <Accordion header={"ข้อมูลการแก้ไข (ข้อมูลใช้ภายนอก)"}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{marginTop:'-20px'}}>
                    {
                        !IsView && objPermission?.LongPlan?.isShow == true
                        ? <Grid item xs={12}>
                            <FormControlLabel
                                disabled={IsView}
                                control={
                                    <Checkbox
                                        checked={IsCanCloning}
                                        onChange={(e) => {
                                            setIsCanCloning(!IsCanCloning);
                                        }}
                                    />
                                }
                                label="ใช้ข้อมูลเดียวกันกับข้อมูลแผนการแก้ไขระยะยาว"
                                labelPlacement="end"
                            />
                        </Grid>
                        : null}
                    <Grid item xs={12} >
                        <InputCustomLabel
                            id="sResolveDetail"
                            name="sResolveDetail"
                            label="รายละเอียดการแก้ไข"
                            required={DataRowResolve.length == 0 ? true : false}
                            multiline={true}
                            maxLength={1000}
                            rows={4}
                            fullWidth
                            disabled={IsView}
                        />
                    </Grid>
                    {
                        IsView
                            ?
                            null
                            : <Grid item xs={12} >
                                <UploadFile
                                    id="sDocFileResolve"
                                    keyID={3}
                                    sTitle={"เอกสารแนบ"}
                                    IsRequired={false}
                                    arrFile={arrFileResolve || []}
                                    setarrFile={setarrFileResolve}
                                    IsFolder={false}
                                    IsFile={true}
                                    IsMultiple={false}
                                    Extension={[...Extension.PDF, ...Extension.Image, ...Extension.Word, ...Extension.Excel, ...Extension.Other]}
                                    IsDrag={false}
                                    nLimitFile={10}
                                    sLimitFile={"MB"}
                                    onClearFile={onClearFileResolve}
                                />
                            </Grid>
                    }
                    <Grid item xs={12} >
                        <DataGridMuiClient
                            isLoading={false}
                            rows={DataRowResolve}
                            HiddenToolHead={true}
                            Columns={dataColumn}
                            backgroundHeaderCustom={"#004290"}
                            sxCustomHeader={{ color: '#ffffff' }}
                        />
                    </Grid>
                </Grid>
            </Accordion>
        </>
    )
}

export default CpnSolutionResolve